const {Component} = require("react"); 
const {computed} = require("mobx");
const BalanceEntry = require("components/backend/balance/BalanceEntry");
const store = require("stores/BalanceEntriesStore"); 
const Loader = require("components/mixins/Loader");

class BalanceList extends Component { 

	/*
	 -------------------------------
	 Init
	 -------------------------------
	 */

	constructor(props) {
		super(props);

		this.state = {
			loading: true,
		}
	}

	componentDidMount() {
		store.fetch().then(() => {
			this.setState({loading: false});
		});
	}

	/*
	 -------------------------------
	 Getters
	 -------------------------------
	 */

	@computed
	get entries() {
		return store.collection;
	}

	@computed
	get hasMore() {
		return store.metadata.has_more;
	}

	/*
	 -------------------------------
	 Methods
	 -------------------------------
	 */

	lazyLoad = (e) => {
		e.preventDefault();
		e.stopPropagation();

		if (!this.state.loading && this.hasMore) {
			this.setState({loading: true});
			let last = this.entries.slice(-1)[0];

			store.append({after_id: last.id})
				.then(() => {
					this.setState({loading: false});
				});
		}
	}

	/*
	 -------------------------------
	 Renders
	 -------------------------------
	 */

	renderEntries() {
		return this.entries.map((entry, index) => (
			<BalanceEntry key={index} {...entry} />
		));
	}

	renderLazyLoad() {
		const markup = this.hasMore ?
			(<button className="btn outline-second" onClick={this.lazyLoad}>Hent flere transaktioner</button>) :
			null;

		return (
			<div className="lazy-load">
				{markup}
			</div>
		);
	}

	render() { 
		return ( 
			<React.Fragment>
				<h3>Betalinger</h3> 
				<Loader active={this.state.loading}></Loader>
				<table className="all-payments">
					<tbody>
						{this.renderEntries()}
					</tbody>
				</table>
				{this.renderLazyLoad()}
			</React.Fragment>
		); 
	} 
} 

module.exports = BalanceList; 



// WEBPACK FOOTER //
// ./resources/js/components/backend/balance/BalanceList.js